import React from 'react';

export default function ContactTile({ user, onTap }) {
  return (
    <div className="contact-tile" onClick={onTap}>
      <div className="contact-avatar">
        <div className="avatar-circle">
          {user.displayName ? user.displayName[0].toUpperCase() : '?'}
        </div>
      </div>
      <div className="contact-info">
        <div className="contact-name">{user.displayName || user.username}</div>
        <div className="contact-phone">{user.phone}</div>
      </div>
      <div className="contact-arrow">›</div>
    </div>
  );
}
